// extracted by mini-css-extract-plugin
export var scrollArea = "_pd-0";